/* ===========================
   Pulse Sidecart — Custom Element
   =========================== */

class CartDrawer extends HTMLElement {
  constructor() {
    super();
    console.log('[SIDECART] constructor');
    this.S = window.pulseSidecartSettings || {};
    this.upsellSwiper = null;
    this.isUpdating = false;
    this.debounceTimers = {};
    this.giftBusy = false;
    this._isRendering = false;
    this._nativeFetch = window.fetch.bind(window);
    this._selfFetch = false;
  }

  connectedCallback() {
    console.log('[SIDECART] connectedCallback');

    var ov = this.querySelector('.pulse-sidecart__overlay');
    if (ov) ov.addEventListener('click', this.close.bind(this));
    this.addEventListener('keyup', (e) => { if (e.code === 'Escape') this.close(); });

    var cartLink = document.getElementById('cart-icon-bubble');
    if (cartLink) {
      console.log('[SIDECART] cart-icon-bubble found, binding click');
      cartLink.setAttribute('role', 'button');
      cartLink.setAttribute('aria-haspopup', 'dialog');
      cartLink.addEventListener('click', (e) => { e.preventDefault(); this.open(); });
    } else {
      console.log('[SIDECART] cart-icon-bubble NOT found');
    }

    document.querySelectorAll('[data-open-cart]').forEach((btn) => {
      btn.addEventListener('click', (e) => { e.preventDefault(); this.open(); });
    });

    if (window.location.href.includes('open-cart=true')) {
      this.open();
      window.history.replaceState({}, document.title, window.location.pathname);
    }

    this.addEventListener('click', (e) => {
      var btn = e.target.closest('[data-action]');
      if (btn) return this._onQtyClick(btn);
      var rem = e.target.closest('[data-remove-line]');
      if (rem) { e.preventDefault(); return this._onRemove(rem); }
      var upsell = e.target.closest('[data-upsell-add]');
      if (upsell) return this._onUpsellAdd(upsell);
    });

    this.addEventListener('change', (e) => {
      if (e.target.matches('[data-subscription-toggle]')) this._onSubToggle(e.target);
      if (e.target.matches('[data-frequency-select]')) this._onFreqChange(e.target);
    });

    console.log('[SIDECART] patching fetch...');
    this._patchFetch();

    this._updateProgress();
    this._updateDelivery();
    this._initUpsell();
  }

  /* ==== OPEN / CLOSE ==== */

  open() {
    console.log('[SIDECART] open()');
    if (this.S.cartItemCount > 0) {
      this.classList.remove('is-empty');
    }
    setTimeout(() => this.classList.add('animate', 'active'));
    document.body.classList.add('overflow-hidden');
  }

  close() {
    console.log('[SIDECART] close()');
    this.classList.remove('active');
    document.body.classList.remove('overflow-hidden');
  }

  /* ==== DAWN COMPAT ==== */

  renderContents(parsedState) {
    console.log('[SIDECART] renderContents() called by external script');
    this.renderCart(true);
  }

  getSectionsToRender() {
    return [
      { id: this.S.sectionId || 'pulse-sidecart', selector: '#CartDrawer' },
      { id: 'cart-icon-bubble' }
    ];
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  /* ==== RENDER CART ==== */

  renderCart(open) {
    console.log('[SIDECART] renderCart(open=' + !!open + '), _isRendering=' + this._isRendering);
    if (this._isRendering) {
      console.log('[SIDECART] renderCart SKIPPED (already rendering)');
      return Promise.resolve();
    }
    this._isRendering = true;
    var self = this;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    var sectionId = this.S.sectionId || 'pulse-sidecart';
    var urlSections = root + '?sections=' + sectionId + ',cart-icon-bubble';

    // Save current progress fill width before DOM replacement
    var prevFill = null;
    var fillEl = self.querySelector('[data-progress-fill]');
    if (fillEl) prevFill = fillEl.style.width || '0%';

    // Save upsell content to avoid flash during re-render
    var prevUpsellSection = self.querySelector('[data-upsell-section]');
    var prevUpsellHtml = prevUpsellSection ? prevUpsellSection.outerHTML : null;

    return Promise.all([
      self._nativeFetch(urlSections).then(function (r) { return r.json(); }),
      self._nativeFetch('/cart.js').then(function (r) { return r.json(); })
    ])
      .then(function (results) {
        var sections = results[0];
        var cart = results[1];
        var cartHtml = sections[sectionId] || '';
        var bubbleHtml = sections['cart-icon-bubble'] || '';

        if (cartHtml) {
          var doc = new DOMParser().parseFromString(cartHtml, 'text/html');
          var nw = doc.querySelector('#CartDrawer');
          var cur = document.querySelector('#CartDrawer');

          if (nw && cur) {
            // Detach LB progress bar before replacing HTML
            var lbEl = cur.querySelector('lb-cart-progress-bar');
            if (lbEl) lbEl.remove();

            cur.innerHTML = nw.innerHTML;
            var ov = cur.querySelector('.pulse-sidecart__overlay');
            if (ov) ov.addEventListener('click', self.close.bind(self));

            // Restore previous fill width instantly (no transition) before animating
            if (prevFill !== null) {
              var newFill = cur.querySelector('[data-progress-fill]');
              if (newFill) {
                newFill.style.transition = 'none';
                newFill.style.width = prevFill;
                newFill.offsetHeight; // force reflow
                newFill.style.transition = '';
              }
            }

            // Restore upsell content to avoid flash
            if (prevUpsellHtml) {
              var newUpsellSection = cur.querySelector('[data-upsell-section]');
              if (newUpsellSection) {
                var tmp = document.createElement('div');
                tmp.innerHTML = prevUpsellHtml;
                newUpsellSection.replaceWith(tmp.firstElementChild);
              }
            }

            // Restore LB progress bar element
            if (lbEl) {
              var progressDiv = cur.querySelector('.pulse-sidecart__progress');
              if (progressDiv) {
                progressDiv.appendChild(lbEl);
              }
            }
          }

          var newWrapper = doc.querySelector('.pulse-sidecart-wrapper');
          if (newWrapper && newWrapper.classList.contains('is-empty')) {
            self.classList.add('is-empty');
          } else {
            self.classList.remove('is-empty');
          }
        }

        if (bubbleHtml) {
          var be = document.getElementById('cart-icon-bubble');
          if (be) {
            var bd = new DOMParser().parseFromString(bubbleHtml, 'text/html').querySelector('.shopify-section');
            if (bd) be.innerHTML = bd.innerHTML;
          }
        }

        self.S.cartTotal = cart.total_price;
        self.S.cartItemCount = cart.item_count;
        self.S.firstProductId = (cart.items && cart.items.length) ? cart.items[0].product_id : null;

        self._updateProgress();
        self._updateDelivery();
        self._initUpsell();


        if (open) self.open();
        console.log('[SIDECART] renderCart DONE');
      })
      .catch(function (err) {
        console.error('[SIDECART] renderCart ERROR:', err);
      })
      .finally(function () { self._isRendering = false; });
  }

  /* ==== QUANTITY ==== */

  _onQtyClick(btn) {
    var input = btn.closest('.pulse-sidecart__qty').querySelector('.pulse-sidecart__qty-val');
    if (!input) return;
    var q = parseInt(input.value);
    q = btn.dataset.action === 'decrease' ? Math.max(0, q - 1) : q + 1;
    input.value = q;
    var line = parseInt(btn.dataset.line);
    clearTimeout(this.debounceTimers[line]);
    this.debounceTimers[line] = setTimeout(() => {
      console.log('[SIDECART] _cartChange from qty, line:', line, 'qty:', q);
      this._cartChange(line, q);
    }, 300);
  }

  _onRemove(btn) {
    var line = parseInt(btn.dataset.removeLine);
    console.log('[SIDECART] _onRemove line:', line);
    this._cartChange(line, 0);
  }

  _cartChange(line, qty) {
    if (this.isUpdating) { console.log('[SIDECART] _cartChange SKIPPED (isUpdating)'); return; }
    this.isUpdating = true;
    var wrap = document.getElementById('CartDrawer-Item-' + line);
    if (wrap) wrap.classList.add('pulse-sidecart__item-wrap--loading');
    var self = this;
    this._cartFetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    })
      .then(function () { console.log('[SIDECART] _cartChange done, calling renderCart'); return self.renderCart(); })
      .catch(console.error)
      .finally(function () { self.isUpdating = false; });
  }

  /* ==== SUBSCRIPTION ==== */

  _onSubToggle(cb) {
    var c = cb.closest('[data-subscription]');
    if (!c) return;
    var line = parseInt(c.dataset.line);
    var inact = c.querySelector('[data-sub-inactive]');
    var act = c.querySelector('[data-sub-active]');
    c.querySelectorAll('[data-subscription-toggle]').forEach(function (x) { x.checked = cb.checked; });
    if (cb.checked) {
      if (inact) inact.style.display = 'none';
      if (act) act.style.display = '';
      var sel = c.querySelector('[data-frequency-select]');
      if (sel) this._cartItem(line, { selling_plan: parseInt(sel.value) });
    } else {
      if (inact) inact.style.display = '';
      if (act) act.style.display = 'none';
      this._cartItem(line, { selling_plan: '' });
    }
  }

  _onFreqChange(sel) {
    var c = sel.closest('[data-subscription]');
    if (!c) return;
    this._cartItem(parseInt(c.dataset.line), { selling_plan: parseInt(sel.value) });
  }

  _cartItem(line, updates) {
    if (this.isUpdating) return;
    this.isUpdating = true;
    var self = this;
    var wrap = this.querySelector('.pulse-sidecart__item-wrap[data-line="' + line + '"]');
    var qtyInput = wrap ? wrap.querySelector('[data-qty-input]') : null;
    var qty = qtyInput ? parseInt(qtyInput.value) : undefined;
    var payload = Object.assign({ line: line }, updates);
    if (qty && !updates.hasOwnProperty('quantity')) payload.quantity = qty;
    this._cartFetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function () { return self.renderCart(); })
      .catch(console.error)
      .finally(function () { self.isUpdating = false; });
  }

  /* ==== PROGRESS BAR ==== */

  _updateProgress() {
    var prog = this.querySelector('.pulse-sidecart__progress');
    if (!prog) return;
    var total = this.S.cartTotal || 0;
    var shipOn = this.S.shippingEnabled;
    var giftOn = this.S.giftEnabled;
    var st = shipOn ? (this.S.shippingThreshold || 4900) : 0;
    var gt = giftOn ? (this.S.giftThreshold || 7900) : 0;
    var max = Math.max(st, gt);
    if (max === 0) return;
    var barMax = max * 1.15;
    var pct = Math.min((total / barMax) * 100, 100);
    var fill = prog.querySelector('[data-progress-fill]');
    if (fill) fill.style.width = pct + '%';

    if (shipOn) {
      var shippingPct = (st / barMax) * 100;
      var cShip = prog.querySelector('[data-circle="shipping"]');
      if (cShip) cShip.style.left = shippingPct + '%';
      var shipReached = total >= st;
      if (cShip) cShip.classList.toggle('pulse-sidecart__bar-circle--reached', shipReached);
      var ms = prog.querySelector('[data-milestone="shipping"]');
      if (ms) { ms.style.left = shippingPct + '%'; ms.classList.toggle('pulse-sidecart__milestone--reached', shipReached); this._toggleIcons(ms, shipReached); }
    }

    if (giftOn) {
      var giftPct = (gt / barMax) * 100;
      var cGift = prog.querySelector('[data-circle="gift"]');
      if (cGift) cGift.style.left = giftPct + '%';
      var giftReached = total >= gt;
      if (cGift) cGift.classList.toggle('pulse-sidecart__bar-circle--reached', giftReached);
      var mg = prog.querySelector('[data-milestone="gift"]');
      if (mg) { mg.style.left = giftPct + '%'; mg.classList.toggle('pulse-sidecart__milestone--reached', giftReached); this._toggleIcons(mg, giftReached); }
    }

    this._preventMilestoneOverlap(prog);

    var txt = prog.querySelector('[data-progress-text]');
    if (txt) {
      var allReached = (!shipOn || total >= st) && (!giftOn || total >= gt);
      if (allReached) {
        var labels = [];
        if (shipOn) labels.push(this.S.shippingLabel);
        if (giftOn) labels.push(this.S.giftLabel);
        txt.innerHTML = '<strong>\u{1F389}</strong> ' + labels.join(' + ');
      } else {
        var next, label;
        if (shipOn && total < st) { next = st; label = this.S.shippingLabel; }
        else if (giftOn && total < gt) { next = gt; label = this.S.giftLabel; }
        else { return; }
        var rem = this._formatMoney(next - total);
        var t = this.S.progressRemainingText || 'Encore AMOUNT pour bénéficier de la REWARD';
        txt.innerHTML = t.replace('AMOUNT', '<strong>' + rem + '</strong>').replace('REWARD', '<strong>' + label + '</strong>');
      }
    }
    this._manageGift(total);
  }

  _toggleIcons(milestone, reached) {
    var d = milestone.querySelector('[data-icon-default]');
    var r = milestone.querySelector('[data-icon-reached]');
    if (d) d.style.display = reached ? 'none' : '';
    if (r) r.style.display = reached ? '' : 'none';
  }

  _preventMilestoneOverlap(prog) {
    var container = prog.querySelector('.pulse-sidecart__milestones');
    if (!container) return;
    var containerWidth = container.offsetWidth;
    if (!containerWidth) return;

    var ms = prog.querySelector('[data-milestone="shipping"]');
    var mg = prog.querySelector('[data-milestone="gift"]');
    var all = [ms, mg].filter(Boolean);
    var gap = 4;

    // Reset transforms
    all.forEach(function(m) { m.style.transform = 'translateX(-50%)'; });

    // Compute each pill's center (from left%) and width
    var items = all.map(function(m) {
      var pill = m.querySelector('.pulse-sidecart__milestone-pill');
      var leftPct = parseFloat(m.style.left) || 0;
      var center = (leftPct / 100) * containerWidth;
      var w = pill ? pill.offsetWidth : 0;
      return { el: m, center: center, w: w, left: center - w / 2, right: center + w / 2 };
    });

    // Sort by center position (left to right)
    items.sort(function(a, b) { return a.center - b.center; });

    // Fix overlap between the two pills
    if (items.length === 2) {
      var a = items[0], b = items[1];
      var overlap = (a.right + gap) - b.left;
      if (overlap > 0) {
        a.left -= overlap / 2;
        a.right -= overlap / 2;
        b.left += overlap / 2;
        b.right += overlap / 2;
      }

      // Clamp right pill to container right edge
      if (b.right > containerWidth) {
        var excess = b.right - containerWidth;
        b.left -= excess;
        b.right -= excess;
        a.left -= excess;
        a.right -= excess;
      }

      // Clamp left pill to container left edge
      if (a.left < 0) {
        var excess = -a.left;
        a.left += excess;
        a.right += excess;
        b.left += excess;
        b.right += excess;
      }

      // Apply transforms: offset = newCenter - originalCenter
      var aNewCenter = (a.left + a.right) / 2;
      var bNewCenter = (b.left + b.right) / 2;
      var aOffset = aNewCenter - a.center;
      var bOffset = bNewCenter - b.center;
      a.el.style.transform = 'translateX(-50%) translateX(' + aOffset + 'px)';
      b.el.style.transform = 'translateX(-50%) translateX(' + bOffset + 'px)';
    } else if (items.length === 1) {
      // Single milestone: just clamp to container
      var item = items[0];
      if (item.right > containerWidth) {
        var offset = -(item.right - containerWidth);
        item.el.style.transform = 'translateX(-50%) translateX(' + offset + 'px)';
      } else if (item.left < 0) {
        var offset = -item.left;
        item.el.style.transform = 'translateX(-50%) translateX(' + offset + 'px)';
      }
    }
  }

  /* ==== GIFT ==== */

  _manageGift(total) {
    if (!this.S.giftEnabled || !this.S.giftVariantId || this.giftBusy) return;
    var gt = this.S.giftThreshold || 7900;
    var giftEl = this.querySelector('.pulse-sidecart__item-wrap[data-is-gift="true"]');
    var inCart = !!giftEl;
    var self = this;
    if (total >= gt && !inCart) {
      this.giftBusy = true;
      this._cartFetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: this.S.giftVariantId, quantity: 1, properties: { _is_gift: 'true' } }] })
      }).then(function () { return self.renderCart(); }).finally(function () { self.giftBusy = false; });
    } else if (total < gt && inCart) {
      var giftLine = parseInt(giftEl.dataset.line);
      this.giftBusy = true;
      this._cartFetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: giftLine, quantity: 0 })
      }).then(function () { return self.renderCart(); }).finally(function () { self.giftBusy = false; });
    }
  }

  /* ==== UPSELL ==== */

  _initUpsell() {
    var wrapper = this.querySelector('[data-upsell-wrapper]');
    if (!wrapper) return;
    var section = this.querySelector('[data-upsell-section]');
    var self = this;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var addWord = ((document.documentElement.lang || 'fr').indexOf('en') === 0) ? 'Add' : ((document.documentElement.lang || 'fr').indexOf('nl') === 0) ? 'Voeg toe' : 'Ajouter';
    if (!this.S.firstProductId) { if (section) section.style.display = 'none'; return; }
    this._nativeFetch(root + 'recommendations/products.json?product_id=' + this.S.firstProductId + '&limit=6')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!data.products || !data.products.length) { if (section) section.style.display = 'none'; return; }
        var ids = [];
        self.querySelectorAll('.pulse-sidecart__item-wrap[data-variant-id]').forEach(function (x) { ids.push(x.dataset.variantId); });
        var prods = data.products.filter(function (p) { return !ids.includes(String(p.variants[0].id)); });
        if (!prods.length) { if (section) section.style.display = 'none'; return; }

        // Fetch flavor metafield for each product via section rendering
        Promise.all(prods.map(function (p) {
          return self._nativeFetch(root + 'products/' + p.handle + '?section_id=sidecart-product-meta')
            .then(function (r) { return r.text(); })
            .then(function (html) {
              var doc = new DOMParser().parseFromString(html, 'text/html');
              var el = doc.querySelector('[data-product-meta]');
              if (el) {
                try { var meta = JSON.parse(el.textContent); p._flavor = meta.flavor || ''; } catch (e) { p._flavor = ''; }
              } else { p._flavor = ''; }
              return p;
            })
            .catch(function () { p._flavor = ''; return p; });
        })).then(function (prods) {
          wrapper.innerHTML = prods.map(function (p) {
            var v = p.variants[0];
            var img = p.featured_image || '';
            var variantText = '';
            if (p._flavor) {
              variantText = '<p class="pulse-sidecart__card-variant">' + self._esc(p._flavor) + '</p>';
            } else {
              var opts = [v.option1, v.option2, v.option3].filter(function(o) { return o && o !== 'Default Title'; });
              if (opts.length) variantText = '<p class="pulse-sidecart__card-variant">' + opts.map(function(o) { return self._esc(o); }).join(' · ') + '</p>';
            }

            return '<div class="swiper-slide"><div class="pulse-sidecart__upsell-card">' +
              '<img class="pulse-sidecart__upsell-img" src="' + self._sizedImg(img, '150x150') + '" alt="' + self._esc(p.title) + '" loading="lazy" width="52" height="52">' +
              '<div class="pulse-sidecart__upsell-info"><p class="pulse-sidecart__upsell-name">' + self._esc(p.title) + '</p>' +
              '<span class="pulse-sidecart__upsell-price">' + self._formatMoney(v.price) + '</span></div>' +
              '<button class="pulse-sidecart__upsell-add" data-upsell-add data-variant-id="' + v.id + '" aria-label="' + addWord + ' ' + self._esc(p.title) + '">' +
              '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg></button>' +
              '</div></div>';
          }).join('');
          if (section) section.style.display = '';
          requestAnimationFrame(function () { self._initSwiper(); });
        });
      })
      .catch(console.error);
  }

  _onUpsellAdd(btn) {
    if (btn.classList.contains('pulse-sidecart__upsell-add--added')) return;
    btn.classList.add('pulse-sidecart__upsell-add--added');
    var self = this;
    this._cartFetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(btn.dataset.variantId), quantity: 1 }] })
    })
      .then(function () { return self.renderCart(); })
      .catch(function () { btn.classList.remove('pulse-sidecart__upsell-add--added'); });
  }

  _initSwiper() {
    if (typeof Swiper === 'undefined') return;
    var c = this.querySelector('.pulse-sidecart__upsell-swiper');
    if (!c) return;
    if (this.upsellSwiper) this.upsellSwiper.destroy(true, true);

    // if (!c.querySelector('.pulse-sidecart__upsell-nav-prev')) {
    //   var prev = document.createElement('button');
    //   prev.type = 'button';
    //   prev.className = 'pulse-sidecart__upsell-nav pulse-sidecart__upsell-nav-prev';
    //   prev.setAttribute('aria-label', 'Précédent');
    //   prev.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><polyline points="15 18 9 12 15 6"/></svg>';
    //   var next = document.createElement('button');
    //   next.type = 'button';
    //   next.className = 'pulse-sidecart__upsell-nav pulse-sidecart__upsell-nav-next';
    //   next.setAttribute('aria-label', 'Suivant');
    //   next.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><polyline points="9 18 15 12 9 6"/></svg>';
    //   c.appendChild(prev);
    //   c.appendChild(next);
    // }

    this.upsellSwiper = new Swiper(c, {
      slidesPerView: 'auto',
      spaceBetween: 8,
      pagination: { el: c.querySelector('.swiper-controls .swiper-pagination'), clickable: true },
      navigation: {
        prevEl: c.querySelector('.swiper-controls .swiper-button-prev'),
        nextEl: c.querySelector('.swiper-controls .swiper-button-next'),
      },
      observer: true,
      observeParents: true
    });
  }

  /* ==== DELIVERY ==== */

  _updateDelivery() {
    var el = this.querySelector('[data-delivery-text]');
    if (!el) return;
    var d = new Date();
    var n = this.S.deliveryDays || 3;
    var added = 0;
    while (added < n) {
      d.setDate(d.getDate() + 1);
      var day = d.getDay();
      if (day !== 0 && day !== 6 && !this._isFrenchHoliday(d)) added++;
    }
    var locale = document.documentElement.lang || 'fr-FR';
    var formatted = d.toLocaleDateString(locale, { weekday: 'long', day: 'numeric', month: 'long' });
    el.innerHTML = (this.S.deliveryPrefix || 'Livraison prévue le') + ' <strong>' + formatted + '</strong>';
  }

  _isFrenchHoliday(date) {
    var y = date.getFullYear();
    var m = date.getMonth() + 1;
    var d = date.getDate();
    var fixed = [[1,1],[5,1],[5,8],[7,14],[8,15],[11,1],[11,11],[12,25]];
    if (fixed.some(function (h) { return h[0] === m && h[1] === d; })) return true;
    var easter = this._computeEaster(y);
    var em = new Date(easter); em.setDate(easter.getDate() + 1);
    var asc = new Date(easter); asc.setDate(easter.getDate() + 39);
    var pen = new Date(easter); pen.setDate(easter.getDate() + 50);
    return [em, asc, pen].some(function (h) {
      return h.getMonth() === date.getMonth() && h.getDate() === date.getDate();
    });
  }

  _computeEaster(year) {
    var a = year % 19;
    var b = Math.floor(year / 100);
    var c = year % 100;
    var d = Math.floor(b / 4);
    var e = b % 4;
    var f = Math.floor((b + 8) / 25);
    var g = Math.floor((b - f + 1) / 3);
    var h = (19 * a + b - d - g + 15) % 30;
    var i = Math.floor(c / 4);
    var k = c % 4;
    var l = (32 + 2 * e + 2 * i - h - k) % 7;
    var mDiv = Math.floor((a + 11 * h + 22 * l) / 451);
    var month = Math.floor((h + l - 7 * mDiv + 114) / 31);
    var day = ((h + l - 7 * mDiv + 114) % 31) + 1;
    return new Date(year, month - 1, day);
  }

  /* ==== PUB/SUB ==== */

  _pub(variantId) {
    try {
      if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'pulse-sidecart', variantId: variantId });
      }
    } catch (e) {}
  }

  /* ==== INTERNAL FETCH (visible to other interceptors like LB) ==== */

  _cartFetch(url, opts) {
    this._selfFetch = true;
    var self = this;
    return window.fetch(url, opts).finally(function () { self._selfFetch = false; });
  }

  /* ==== FETCH INTERCEPTOR ==== */

  _patchFetch() {
    var self = this;
    var original = this._nativeFetch;
    var cartEndpoints = ['/cart/add', '/cart/change', '/cart/update', '/cart/clear'];
    var timer = null;

    window.fetch = function () {
      var url = typeof arguments[0] === 'string' ? arguments[0] : (arguments[0] && arguments[0].url) || '';
      var isCart = cartEndpoints.some(function (ep) { return url.indexOf(ep) !== -1; });

      // If this is our own call, skip interception but still pass through
      if (self._selfFetch) {
        return original.apply(window, arguments);
      }

      var result = original.apply(window, arguments);

      if (isCart) {
        console.log('[SIDECART] INTERCEPTED external fetch to:', url);
        result.then(function (response) {
          return response.clone();
        }).then(function () {
          clearTimeout(timer);
          timer = setTimeout(function () {
            self.renderCart(true);
          }, 300);
        }).catch(function (err) {
          console.log('[SIDECART] external fetch error:', err);
        });
      }

      return result;
    };
  }

  /* ==== HELPERS ==== */

  _formatMoney(c) { return (parseInt(c) / 100).toFixed(2).replace('.', ',') + ' \u20AC'; }
  _esc(s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; }
  _sizedImg(url, sz) {
    if (!url) return '';
    var m = url.match(/\.(jpg|jpeg|gif|png|bmp|tiff|tif|webp)(\?v=\d+)?/i);
    if (m) return url.split(m[0])[0] + '_' + sz + m[0];
    return url;
  }
}

customElements.define('cart-drawer', CartDrawer);
